export default __webpack_public_path__ + "static/media/item-design1.fa3ce5e0.png";